<template>
    <div>
        <h3 class="pd-tb"><translate>Billing invoice history</translate></h3>

        <b-table
            :fields="fields"
            :items="items"
            :class="['gk-table gk-table--responsive gk-table--striped gk-table--hover']"
            :busy="loading"
            :per-page="perPage"
            :current-page="currentPage"
            show-empty
            table-busy
            >
            <template #cell(total_amount)="data">
                <div class="text-right">€ {{data.value | formatNumber}}</div>
            </template>
            <template #cell(actions)="data">
                    <GekkoButton @click="download(data.item)" icon="fa-solid fa-download" variant="link" class="pull-right text-info"/>
            </template>
            <template #table-busy="">
                <LoadingSpinner min-height/>
            </template>
        </b-table>

        <b-pagination
            class="paginator pd-tb"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage">
        </b-pagination>
    </div>
</template>

<script>
import InvoiceService from "@/store/services/invoice.service";
import GekkoButton from "@/components/GekkoButton";
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner";

export default {
    name: "BillingInvoices",
    components: {GekkoButton, LoadingSpinner},
    data() {
        return {
            fields: [
                {key: "invoice_date", label: this.$gettext('Date')},
                {key: "total_amount", label: this.$gettext('Amount')},
                {key: 'actions', label: ""}
            ],
            items: [],
            currentPage: 1,
            perPage: 10,
            loading: true
        }
    },
    created() {
        InvoiceService.getPremiumInvoices().then((response) => {
            this.items = response.data;
            this.loading = false;
        });
    },
    methods: {
        download(item) {
            location.href = InvoiceService.downloadPremiumSubscriptionUrl(item.id);
        }
    },
    computed: {
        rows() {
            return this.items.length;
        }
    }
}
</script>

<style scoped>
.pd-tb {
    padding-top: 1rem;
    padding-bottom: 1rem;
}

.paginator {
    justify-content: center;
}
</style>